//css
import "./Home.css";
import homePageLogo from "../../assets/images/sprayzapp-home2.jpeg";
import { Col, Container, Row } from "react-bootstrap";
import { useEffect } from "react";
function Home(props) {
  useEffect(() => {
    props.setTab("home");
  }, [props]);

  return (
    <Container style={{ backgroundColor: "#3e8bd2", height: "100vh" }}>
      <Row>
        <img
          src={homePageLogo}
          alt={"home-icon"}
          style={{
            padding: "inherit",
            height: "auto",
            maxHeight: "100vh",
            display: "block",
            margin: "0 auto",
          }}
        />
      </Row>
      <Row>
        <span className="home-tag-line">
          MANAGE, TRACK, GROW <span className="home-tag-line-normal">and</span>{" "}
          KEEP SPRAYING <span className="home-tag-line-normal">with</span>{" "}
          SPRAYZAPP
        </span>
      </Row>
    </Container>
  );
}
export default Home;
